import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { TextField, Button, Box, Typography, Grid, Paper } from "@mui/material";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { SettingsStyles, addEventMainStyles } from "../../../Styles/styles";
import { Input } from "antd";
import { useContactUsMutation } from "../../../Redux/apis/ApiSlice";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

let DefaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});
L.Marker.prototype.options.icon = DefaultIcon;

const ContactUs = () => {
  const navigate = useNavigate();

  const [sendContactEmail] = useContactUsMutation();
  const [formData, setFormData] = useState({
    name: "",
    message: "",
  });
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const getEmailFromLocalStorage = () => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        return userData.email;
      } catch (error) {
        console.error("Error parsing userData from localStorage:", error);
        return null; // Handle potential parsing errors
      }
    } else {
      return null; // Handle case where userData is not found
    }
  };

  const email = getEmailFromLocalStorage();
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission behavior

    try {
      // Check if the email is available in local storage
      if (!email) {
        notification.error({
          message:
            // "Email address not found. Please provide an email address.",
            "Email address not found!",

        });
        return; // Exit early to prevent sending without email
      }

      // Check if name and message are filled
      if (!formData?.name || !formData?.message) {
        notification.error({
          message: "Fill both fields!",
        });
        return; // Exit early if either name or message is missing
      }

      // Send contact email using ContactUsMutation
      const response = await sendContactEmail({
        name: formData?.name,
        email,
        message: formData?.message,
      });

      notification.success({
        message: "Message sent successfully!",
      });

      // Clear form data after successful submission
      setFormData({
        name: "",
        message: "",
      });
    } catch (error) {
      notification.error({
        message: error.data?.message || "Failed to send the message!",
      });
    }
  };

  return (
    <>
      <Box sx={{ padding: 1 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography
              gutterBottom
              sx={{ fontSize: "30px", fontWeight: "600" }}
            >
              Get in touch
            </Typography>
            <Typography variant="body1" gutterBottom>
              We’d love to hear from you! Fill out the form below.
            </Typography>
            <form noValidate autoComplete="off">
              <Box mb={2}>
                <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                  Name
                </Typography>
                <Input
                  style={{ marginTop: "10px" }}
                  size="large"
                  placeholder="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Box>
              <Box>
                <Typography sx={addEventMainStyles.AddEventFieldTypo}>
                  Message
                </Typography>
                <TextField
                  sx={{ marginTop: "10px" }}
                  variant="outlined"
                  required
                  fullWidth
                  placeholder="Message*"
                  type="text"
                  multiline
                  rows={4}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  mt: 2,
                  flexDirection: {
                    xl: "row",
                    lg: "row",
                    md: "column",
                    sm: "row",
                    xs: "column",
                  },
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                <Button>
                  <a
                    href="tel:+923488273457"
                    style={{ textDecoration: "none" }}
                  >
                    <Paper
                      elevation={1}
                      sx={{ p: 2, display: "flex", alignItems: "center" }}
                    >
                      <Box
                        sx={{
                          mr: 1,
                          textAlign: "center",
                          width: {
                            xs: 200,
                            sm: 200,
                            md: 200,
                            lg: 200,
                            xl: 200,
                          },
                        }}
                      >
                        <svg
                          width="53"
                          height="68"
                          viewBox="0 0 53 68"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.9432 53.1477H9.17045C9.10227 52.7689 8.97538 52.4356 8.78977 52.1477C8.60417 51.8598 8.37689 51.6155 8.10795 51.4148C7.83902 51.214 7.53788 51.0625 7.20455 50.9602C6.875 50.858 6.52462 50.8068 6.15341 50.8068C5.48295 50.8068 4.88258 50.9754 4.35227 51.3125C3.82576 51.6496 3.40909 52.1439 3.10227 52.7955C2.79924 53.447 2.64773 54.2424 2.64773 55.1818C2.64773 56.1288 2.79924 56.928 3.10227 57.5795C3.40909 58.2311 3.82765 58.7235 4.35795 59.0568C4.88826 59.3902 5.48485 59.5568 6.14773 59.5568C6.51515 59.5568 6.86364 59.5076 7.19318 59.4091C7.52652 59.3068 7.82765 59.1572 8.09659 58.9602C8.36553 58.7633 8.5928 58.5227 8.77841 58.2386C8.9678 57.9508 9.09848 57.6212 9.17045 57.25L10.9432 57.2557C10.8485 57.8277 10.6648 58.3542 10.392 58.8352C10.1231 59.3125 9.77652 59.7254 9.35227 60.0739C8.93182 60.4186 8.45076 60.6856 7.90909 60.875C7.36742 61.0644 6.77652 61.1591 6.13636 61.1591C5.12879 61.1591 4.23106 60.9205 3.44318 60.4432C2.6553 59.9621 2.03409 59.2746 1.57955 58.3807C1.12879 57.4867 0.903409 56.4205 0.903409 55.1818C0.903409 53.9394 1.13068 52.8731 1.58523 51.983C2.03977 51.089 2.66098 50.4034 3.44886 49.9261C4.23674 49.4451 5.13258 49.2045 6.13636 49.2045C6.75379 49.2045 7.32955 49.2936 7.86364 49.4716C8.40152 49.6458 8.88447 49.9034 9.3125 50.2443C9.74053 50.5814 10.0947 50.9943 10.375 51.483C10.6553 51.9678 10.8447 52.5227 10.9432 53.1477ZM15.1274 61.1932C14.5744 61.1932 14.0744 61.0909 13.6274 60.8864C13.1805 60.678 12.8263 60.3769 12.5649 59.983C12.3074 59.589 12.1786 59.1061 12.1786 58.5341C12.1786 58.0417 12.2733 57.6364 12.4627 57.3182C12.6521 57 12.9077 56.7481 13.2297 56.5625C13.5517 56.3769 13.9115 56.2367 14.3093 56.142C14.707 56.0473 15.1123 55.9754 15.5252 55.9261C16.0479 55.8655 16.4721 55.8163 16.7979 55.7784C17.1237 55.7367 17.3604 55.6705 17.5081 55.5795C17.6559 55.4886 17.7297 55.3409 17.7297 55.1364V55.0966C17.7297 54.6004 17.5896 54.2159 17.3093 53.9432C17.0327 53.6705 16.6199 53.5341 16.0706 53.5341C15.4987 53.5341 15.0479 53.661 14.7184 53.9148C14.3926 54.1648 14.1672 54.4432 14.0422 54.75L12.4456 54.3864C12.635 53.8561 12.9115 53.428 13.2752 53.1023C13.6426 52.7727 14.0649 52.5341 14.5422 52.3864C15.0195 52.2348 15.5214 52.1591 16.0479 52.1591C16.3964 52.1591 16.7657 52.2008 17.1559 52.2841C17.5498 52.3636 17.9172 52.5114 18.2581 52.7273C18.6028 52.9432 18.885 53.2519 19.1047 53.6534C19.3244 54.0511 19.4343 54.5682 19.4343 55.2045V61H17.7752V59.8068H17.707C17.5971 60.0265 17.4324 60.2424 17.2127 60.4545C16.993 60.6667 16.7108 60.8428 16.3661 60.983C16.0214 61.1231 15.6085 61.1932 15.1274 61.1932ZM15.4968 59.8295C15.9665 59.8295 16.368 59.7367 16.7013 59.5511C17.0384 59.3655 17.2941 59.1231 17.4684 58.8239C17.6464 58.5208 17.7354 58.197 17.7354 57.8523V56.7273C17.6748 56.7879 17.5574 56.8447 17.3831 56.8977C17.2127 56.947 17.0176 56.9905 16.7979 57.0284C16.5782 57.0625 16.3642 57.0947 16.1559 57.125C15.9475 57.1515 15.7733 57.1742 15.6331 57.1932C15.3036 57.2348 15.0024 57.3049 14.7297 57.4034C14.4608 57.5019 14.2449 57.6439 14.082 57.8295C13.9229 58.0114 13.8434 58.2538 13.8434 58.5568C13.8434 58.9773 13.9987 59.2955 14.3093 59.5114C14.6199 59.7235 15.0157 59.8295 15.4968 59.8295ZM23.0759 49.3636V61H21.377V49.3636H23.0759ZM26.7403 49.3636V61H25.0414V49.3636H26.7403ZM38.1486 57.3807V52.2727H39.8531V61H38.1827V59.4886H38.0918C37.891 59.9545 37.569 60.3428 37.1259 60.6534C36.6865 60.9602 36.1391 61.1136 35.4838 61.1136C34.9232 61.1136 34.427 60.9905 33.9952 60.7443C33.5671 60.4943 33.23 60.125 32.9838 59.6364C32.7414 59.1477 32.6202 58.5436 32.6202 57.8239V52.2727H34.319V57.6193C34.319 58.214 34.4838 58.6875 34.8134 59.0398C35.1429 59.392 35.5709 59.5682 36.0974 59.5682C36.4156 59.5682 36.7319 59.4886 37.0463 59.3295C37.3645 59.1705 37.6277 58.9299 37.8361 58.608C38.0482 58.286 38.1524 57.8769 38.1486 57.3807ZM48.3556 54.4034L46.8158 54.6761C46.7514 54.4792 46.6491 54.2917 46.509 54.1136C46.3726 53.9356 46.187 53.7898 45.9522 53.6761C45.7173 53.5625 45.4238 53.5057 45.0715 53.5057C44.5904 53.5057 44.1889 53.6136 43.8669 53.8295C43.545 54.0417 43.384 54.3163 43.384 54.6534C43.384 54.9451 43.4919 55.1799 43.7078 55.358C43.9238 55.536 44.2722 55.6818 44.7533 55.7955L46.1397 56.1136C46.9427 56.2992 47.5412 56.5852 47.9351 56.9716C48.3291 57.358 48.526 57.8598 48.526 58.4773C48.526 59 48.3745 59.4659 48.0715 59.875C47.7722 60.2803 47.3537 60.5985 46.8158 60.8295C46.2817 61.0606 45.6624 61.1761 44.9578 61.1761C43.9806 61.1761 43.1832 60.9678 42.5658 60.5511C41.9484 60.1307 41.5696 59.5341 41.4294 58.7614L43.0715 58.5114C43.1738 58.9394 43.384 59.2633 43.7022 59.483C44.0203 59.6989 44.4351 59.8068 44.9465 59.8068C45.5033 59.8068 45.9484 59.6913 46.2817 59.4602C46.615 59.2254 46.7817 58.9394 46.7817 58.6023C46.7817 58.3295 46.6794 58.1004 46.4749 57.9148C46.2741 57.7292 45.9654 57.589 45.5488 57.4943L44.0715 57.1705C43.2571 56.9848 42.6548 56.6894 42.2647 56.2841C41.8783 55.8788 41.6851 55.3655 41.6851 54.7443C41.6851 54.2292 41.8291 53.7784 42.1169 53.392C42.4048 53.0057 42.8025 52.7045 43.3101 52.4886C43.8177 52.2689 44.3991 52.1591 45.0544 52.1591C45.9976 52.1591 46.74 52.3636 47.2817 52.7727C47.8234 53.178 48.1813 53.7216 48.3556 54.4034Z"
                            fill="rgba(0, 0, 0, 0.87)"
                          />
                          <rect
                            x="9"
                            y="0.530273"
                            width="35.7925"
                            height="32.8696"
                            rx="12"
                            fill="rgba(0, 0, 0, 0.87)"
                          />
                          <path
                            d="M25.0573 10.5081C24.8211 9.91753 24.2491 9.53027 23.6131 9.53027H21.4736C20.6598 9.53027 20 10.1899 20 11.0038C20 17.9219 25.6082 23.5303 32.5262 23.5303C33.34 23.5303 33.9996 22.8704 33.9996 22.0565L34 19.9167C34 19.2806 33.6129 18.7087 33.0223 18.4725L30.9718 17.6526C30.4413 17.4404 29.8373 17.5359 29.3984 17.9016L28.8692 18.343C28.2511 18.8581 27.3417 18.8171 26.7729 18.2482L25.2827 16.7567C24.7138 16.1878 24.6718 15.2791 25.1868 14.661L25.6281 14.1318C25.9939 13.6929 26.0902 13.0887 25.878 12.5582L25.0573 10.5081Z"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <Typography variant="body2">(404) 808-4417</Typography>
                      </Box>
                    </Paper>
                  </a>
                </Button>
                <Button
                  component="a"
                  href="mailto:ticketgenius.official@gmail.com"
                >
                  <Paper
                    elevation={1}
                    sx={{ p: 2, display: "flex", alignItems: "center" }}
                  >
                    <Box
                      sx={{
                        mr: 1,
                        textAlign: "center",
                        width: { xs: 200, sm: 200, md: 200, lg: 200, xl: 200 },
                      }}
                    >
                      <svg
                        width="65"
                        height="68"
                        viewBox="0 0 65 68"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.27841 61V49.3636H8.57386V50.875H3.03409V54.4205H8.19318V55.9261H3.03409V59.4886H8.64205V61H1.27841ZM10.4627 61V52.2727H12.0934V53.6932H12.2013C12.3831 53.2121 12.6805 52.8371 13.0934 52.5682C13.5062 52.2955 14.0005 52.1591 14.5763 52.1591C15.1596 52.1591 15.6483 52.2955 16.0422 52.5682C16.4399 52.8409 16.7335 53.2159 16.9229 53.6932H17.0138C17.2221 53.2273 17.5536 52.8561 18.0081 52.5795C18.4627 52.2992 19.0043 52.1591 19.6331 52.1591C20.4248 52.1591 21.0706 52.4072 21.5706 52.9034C22.0744 53.3996 22.3263 54.1477 22.3263 55.1477V61H20.6274V55.3068C20.6274 54.7159 20.4665 54.2879 20.1445 54.0227C19.8225 53.7576 19.438 53.625 18.9911 53.625C18.438 53.625 18.0081 53.7955 17.7013 54.1364C17.3945 54.4735 17.2411 54.9072 17.2411 55.4375V61H15.5479V55.1989C15.5479 54.7254 15.4002 54.3447 15.1047 54.0568C14.8093 53.7689 14.4248 53.625 13.9513 53.625C13.6293 53.625 13.332 53.7102 13.0593 53.8807C12.7903 54.0473 12.5725 54.2803 12.4059 54.5795C12.243 54.8788 12.1615 55.2254 12.1615 55.6193V61H10.4627ZM26.8231 61.1932C26.27 61.1932 25.77 61.0909 25.3231 60.8864C24.8761 60.678 24.5219 60.3769 24.2606 59.983C24.003 59.589 23.8742 59.1061 23.8742 58.5341C23.8742 58.0417 23.9689 57.6364 24.1583 57.3182C24.3477 57 24.6034 56.7481 24.9253 56.5625C25.2473 56.3769 25.6072 56.2367 26.0049 56.142C26.4026 56.0473 26.8079 55.9754 27.2208 55.9261C27.7435 55.8655 28.1678 55.8163 28.4935 55.7784C28.8193 55.7367 29.056 55.6705 29.2038 55.5795C29.3515 55.4886 29.4253 55.3409 29.4253 55.1364V55.0966C29.4253 54.6004 29.2852 54.2159 29.0049 53.9432C28.7284 53.6705 28.3155 53.5341 27.7663 53.5341C27.1943 53.5341 26.7435 53.661 26.414 53.9148C26.0882 54.1648 25.8628 54.4432 25.7378 54.75L24.1413 54.3864C24.3306 53.8561 24.6072 53.428 24.9708 53.1023C25.3382 52.7727 25.7606 52.5341 26.2378 52.3864C26.7151 52.2348 27.217 52.1591 27.7435 52.1591C28.092 52.1591 28.4613 52.2008 28.8515 52.2841C29.2454 52.3636 29.6128 52.5114 29.9538 52.7273C30.2984 52.9432 30.5806 53.2519 30.8003 53.6534C31.02 54.0511 31.1299 54.5682 31.1299 55.2045V61H29.4708V59.8068H29.4026C29.2928 60.0265 29.128 60.2424 28.9083 60.4545C28.6886 60.6667 28.4064 60.8428 28.0617 60.983C27.717 61.1231 27.3041 61.1932 26.8231 61.1932ZM27.1924 59.8295C27.6621 59.8295 28.0636 59.7367 28.3969 59.5511C28.7341 59.3655 28.9897 59.1231 29.164 58.8239C29.342 58.5208 29.431 58.197 29.431 57.8523V56.7273C29.3704 56.7879 29.253 56.8447 29.0788 56.8977C28.9083 56.947 28.7132 56.9905 28.4935 57.0284C28.2738 57.0625 28.0598 57.0947 27.8515 57.125C27.6431 57.1515 27.4689 57.1742 27.3288 57.1932C26.9992 57.2348 26.6981 57.3049 26.4253 57.4034C26.1564 57.5019 25.9405 57.6439 25.7776 57.8295C25.6185 58.0114 25.539 58.2538 25.539 58.5568C25.539 58.9773 25.6943 59.2955 26.0049 59.5114C26.3155 59.7235 26.7113 59.8295 27.1924 59.8295ZM33.0727 61V52.2727H34.7715V61H33.0727ZM33.9306 50.9261C33.6352 50.9261 33.3814 50.8277 33.1693 50.6307C32.9609 50.4299 32.8568 50.1913 32.8568 49.9148C32.8568 49.6345 32.9609 49.3958 33.1693 49.1989C33.3814 48.9981 33.6352 48.8977 33.9306 48.8977C34.2261 48.8977 34.478 48.9981 34.6863 49.1989C34.8984 49.3958 35.0045 49.6345 35.0045 49.9148C35.0045 50.1913 34.8984 50.4299 34.6863 50.6307C34.478 50.8277 34.2261 50.9261 33.9306 50.9261ZM38.4359 49.3636V61H36.737V49.3636H38.4359ZM49.8442 57.3807V52.2727H51.5488V61H49.8783V59.4886H49.7874C49.5866 59.9545 49.2647 60.3428 48.8215 60.6534C48.3821 60.9602 47.8347 61.1136 47.1794 61.1136C46.6188 61.1136 46.1226 60.9905 45.6908 60.7443C45.2628 60.4943 44.9256 60.125 44.6794 59.6364C44.437 59.1477 44.3158 58.5436 44.3158 57.8239V52.2727H46.0147V57.6193C46.0147 58.214 46.1794 58.6875 46.509 59.0398C46.8385 59.392 47.2666 59.5682 47.7931 59.5682C48.1113 59.5682 48.4275 59.4886 48.7419 59.3295C49.0601 59.1705 49.3234 58.9299 49.5317 58.608C49.7438 58.286 49.848 57.8769 49.8442 57.3807ZM60.0512 54.4034L58.5114 54.6761C58.447 54.4792 58.3448 54.2917 58.2046 54.1136C58.0682 53.9356 57.8826 53.7898 57.6478 53.6761C57.4129 53.5625 57.1194 53.5057 56.7671 53.5057C56.286 53.5057 55.8845 53.6136 55.5626 53.8295C55.2406 54.0417 55.0796 54.3163 55.0796 54.6534C55.0796 54.9451 55.1876 55.1799 55.4035 55.358C55.6194 55.536 55.9679 55.6818 56.4489 55.7955L57.8353 56.1136C58.6383 56.2992 59.2368 56.5852 59.6307 56.9716C60.0247 57.358 60.2216 57.8598 60.2216 58.4773C60.2216 59 60.0701 59.4659 59.7671 59.875C59.4679 60.2803 59.0493 60.5985 58.5114 60.8295C57.9773 61.0606 57.358 61.1761 56.6535 61.1761C55.6762 61.1761 54.8788 60.9678 54.2614 60.5511C53.644 60.1307 53.2652 59.5341 53.1251 58.7614L54.7671 58.5114C54.8694 58.9394 55.0796 59.2633 55.3978 59.483C55.716 59.6989 56.1307 59.8068 56.6421 59.8068C57.1989 59.8068 57.644 59.6913 57.9773 59.4602C58.3107 59.2254 58.4773 58.9394 58.4773 58.6023C58.4773 58.3295 58.3751 58.1004 58.1705 57.9148C57.9698 57.7292 57.661 57.589 57.2444 57.4943L55.7671 57.1705C54.9527 56.9848 54.3504 56.6894 53.9603 56.2841C53.5739 55.8788 53.3807 55.3655 53.3807 54.7443C53.3807 54.2292 53.5247 53.7784 53.8126 53.392C54.1004 53.0057 54.4982 52.7045 55.0057 52.4886C55.5133 52.2689 56.0948 52.1591 56.7501 52.1591C57.6932 52.1591 58.4357 52.3636 58.9773 52.7727C59.519 53.178 59.8769 53.7216 60.0512 54.4034Z"
                          fill="rgba(0, 0, 0, 0.87)"
                        />
                        <rect
                          x="14"
                          y="0.530273"
                          width="35.7925"
                          height="32.8696"
                          rx="12"
                          fill="rgba(0, 0, 0, 0.87)"
                        />
                        <path
                          d="M26.6667 12.2446L30.7384 15.539L30.7398 15.5402C31.1919 15.8955 31.4181 16.0732 31.6658 16.1419C31.8848 16.2025 32.115 16.2025 32.334 16.1419C32.582 16.0731 32.8088 15.8949 33.2617 15.539C33.2617 15.539 35.8734 13.3917 37.3333 12.2446M26 19.2447V13.8161C26 13.0161 26 12.6157 26.1453 12.3101C26.2732 12.0413 26.477 11.8229 26.7279 11.686C27.0131 11.5303 27.3867 11.5303 28.1335 11.5303H35.8668C36.6135 11.5303 36.9864 11.5303 37.2716 11.686C37.5225 11.8229 37.727 12.0413 37.8548 12.3101C38 12.6154 38 13.0153 38 13.8138V19.2471C38 20.0456 38 20.4449 37.8548 20.7502C37.727 21.019 37.5225 21.2378 37.2716 21.3747C36.9867 21.5303 36.614 21.5303 35.8687 21.5303H28.1313C27.386 21.5303 27.0128 21.5303 26.7279 21.3747C26.477 21.2378 26.2732 21.019 26.1453 20.7502C26 20.4446 26 20.0448 26 19.2447Z"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>

                      <Typography
                        variant="body2"
                        sx={{ fontSize: 11, fontWeight: 500, height: 20 }}
                      >
                        help@gxtickets.com
                      </Typography>
                    </Box>
                  </Paper>
                </Button>
              </Box>
            </form>
          </Grid>
          <Grid item xs={12} md={6} sx={{ mt: 4 }}>
            <MapContainer
              center={[40.7128, -74.006]}
              zoom={13}
              style={{ height: "400px", width: "100%" }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <Marker position={[40.7128, -74.006]}>
                <Popup>We are here!</Popup>
              </Marker>
            </MapContainer>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            // mt: { xl: 15, lg: 1, md: 1, xs: 1 },
            // mr: 2,
            my: 3,
            float: "right",
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Button
            sx={SettingsStyles.UpdateBtnStyles}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Send
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ContactUs;
